import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  Pagination,
} from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

// Mock data for overpressure events
const overpressureData = [
  { id: 1, month: "April", count: 12 },
  { id: 2, month: "May", count: 18 },
  { id: 3, month: "June", count: 9 },
  { id: 4, month: "July", count: 15 },
];

const deviceData = [
  {
    id: 1,
    name: "Device A",
    linePressure: 120,
    setPressure: 100,
    margin: 20,
    dateTime: "2025-07-14T09:15:00Z",
  },
  {
    id: 2,
    name: "Device B",
    linePressure: 115,
    setPressure: 105,
    margin: 10,
    dateTime: "2025-07-13T14:22:00Z",
  },
  {
    id: 3,
    name: "Device C",
    linePressure: 130,
    setPressure: 110,
    margin: 20,
    dateTime: "2025-07-12T18:45:00Z",
  },
  {
    id: 4,
    name: "Device D",
    linePressure: 140,
    setPressure: 120,
    margin: 20,
    dateTime: "2025-07-11T07:30:00Z",
  },
];

export const totalOverpressureCount = overpressureData.reduce(
  (sum, d) => sum + d.count,
  0
);

const ROWS_PER_PAGE = 3;

const Overpressure = () => {
  const [page, setPage] = useState(1);
  const paginatedData = deviceData.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE
  );
  const pageCount = Math.ceil(deviceData.length / ROWS_PER_PAGE);

  return (
    <Card sx={{ mb: 3, backgroundColor: "#fff", boxShadow: 0 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Overpressure Events (Last 4 Months)
        </Typography>
        <Box sx={{ height: 300 }}>
          <BarChart
            xAxis={[
              {
                data: overpressureData.map((d) => d.month),
                label: "Month",
                scaleType: "band",
              },
            ]}
            series={[
              {
                data: overpressureData.map((d) => d.count),
                label: "Count",
                color: "#22C55E",
              },
            ]}
            height={300}
          />
        </Box>
        {/* Overpressure Events Table */}
        <Typography variant="subtitle1" sx={{ mt: 4, mb: 1 }}>
          Device Overpressure Events
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: 300,
            borderRadius: 2,
            boxShadow: 1,
            mb: 2,
            backgroundColor: "#fff", // Add this line
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>ID</b>
                </TableCell>
                <TableCell>
                  <b>Device Name</b>
                </TableCell>
                <TableCell>
                  <b>Line Pressure</b>
                </TableCell>
                <TableCell>
                  <b>Set Pressure</b>
                </TableCell>
                <TableCell>
                  <b>Margin</b>
                </TableCell>
                <TableCell>
                  <b>Date/Time</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((dev) => (
                <TableRow key={dev.id}>
                  <TableCell>{dev.id}</TableCell>
                  <TableCell>{dev.name}</TableCell>
                  <TableCell>{dev.linePressure}</TableCell>
                  <TableCell>{dev.setPressure}</TableCell>
                  <TableCell>{dev.margin}</TableCell>
                  <TableCell>
                    {new Date(dev.dateTime).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={(_, value) => setPage(value)}
            shape="rounded"
            showFirstButton
            showLastButton
            sx={{
              "& .MuiPaginationItem-root": {
                fontSize: "1 rem",
                minWidth: 40,
                height: 40,
              },
              "& .Mui-selected": {
                backgroundColor: "#22C55E !important",
                color: "#fff !important",
                fontWeight: "bold",
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default Overpressure;
